// 헥사코드 색상에서 R, G, B 값을 추출하는 함수
const hexStringToRgba = (hex: string, alpha: number = 1): string => {
  let hexWithoutHash = hex.replace('#', '')

  if (hexWithoutHash.length === 3) {
    hexWithoutHash = hexWithoutHash
      .split('')
      .map(char => char + char)
      .join('')
  }

  const r = parseInt(hexWithoutHash.substring(0, 2), 16)
  const g = parseInt(hexWithoutHash.substring(2, 4), 16)
  const b = parseInt(hexWithoutHash.substring(4, 6), 16)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// CSS에서 제공하는 모든 기본 색상
const predefinedColors: { [key: string]: string } = {
  aliceblue: 'rgba(240, 248, 255, 1)',
  antiquewhite: 'rgba(250, 235, 215, 1)',
  aqua: 'rgba(0, 255, 255, 1)',
  aquamarine: 'rgba(127, 255, 212, 1)',
  azure: 'rgba(240, 255, 255, 1)',
  beige: 'rgba(245, 245, 220, 1)',
  bisque: 'rgba(255, 228, 196, 1)',
  black: 'rgba(0, 0, 0, 1)',
  blanchedalmond: 'rgba(255, 235, 205, 1)',
  blue: 'rgba(0, 0, 255, 1)',
  blueviolet: 'rgba(138, 43, 226, 1)',
  brown: 'rgba(165, 42, 42, 1)',
  burlywood: 'rgba(222, 184, 135, 1)',
  cadetblue: 'rgba(95, 158, 160, 1)',
  chartreuse: 'rgba(127, 255, 0, 1)',
  chocolate: 'rgba(210, 105, 30, 1)',
  coral: 'rgba(255, 127, 80, 1)',
  cornflowerblue: 'rgba(100, 149, 237, 1)',
  cornsilk: 'rgba(255, 248, 220, 1)',
  crimson: 'rgba(220, 20, 60, 1)',
  cyan: 'rgba(0, 255, 255, 1)',
  darkblue: 'rgba(0, 0, 139, 1)',
  darkcyan: 'rgba(0, 139, 139, 1)',
  darkgoldenrod: 'rgba(184, 134, 11, 1)',
  darkgray: 'rgba(169, 169, 169, 1)',
  darkgreen: 'rgba(0, 100, 0, 1)',
  darkgrey: 'rgba(169, 169, 169, 1)',
  darkkhaki: 'rgba(189, 183, 107, 1)',
  darkmagenta: 'rgba(139, 0, 139, 1)',
  darkolivegreen: 'rgba(85, 107, 47, 1)',
  darkorange: 'rgba(255, 140, 0, 1)',
  darkorchid: 'rgba(153, 50, 204, 1)',
  darkred: 'rgba(139, 0, 0, 1)',
  darksalmon: 'rgba(233, 150, 122, 1)',
  darkseagreen: 'rgba(143, 188, 143, 1)',
  darkslateblue: 'rgba(72, 61, 139, 1)',
  darkslategray: 'rgba(47, 79, 79, 1)',
  darkslategrey: 'rgba(47, 79, 79, 1)',
  darkturquoise: 'rgba(0, 206, 209, 1)',
  darkviolet: 'rgba(148, 0, 211, 1)',
  deeppink: 'rgba(255, 20, 147, 1)',
  deepskyblue: 'rgba(0, 191, 255, 1)',
  dimgray: 'rgba(105, 105, 105, 1)',
  dimgrey: 'rgba(105, 105, 105, 1)',
  dodgerblue: 'rgba(30, 144, 255, 1)',
  firebrick: 'rgba(178, 34, 34, 1)',
  floralwhite: 'rgba(255, 250, 240, 1)',
  forestgreen: 'rgba(34, 139, 34, 1)',
  fuchsia: 'rgba(255, 0, 255, 1)',
  gainsboro: 'rgba(220, 220, 220, 1)',
  ghostwhite: 'rgba(248, 248, 255, 1)',
  gold: 'rgba(255, 215, 0, 1)',
  goldenrod: 'rgba(218, 165, 32, 1)',
  gray: 'rgba(128, 128, 128, 1)',
  green: 'rgba(0, 128, 0, 1)',
  greenyellow: 'rgba(173, 255, 47, 1)',
  grey: 'rgba(128, 128, 128, 1)',
  honeydew: 'rgba(240, 255, 240, 1)',
  hotpink: 'rgba(255, 105, 180, 1)',
  indianred: 'rgba(205, 92, 92, 1)',
  indigo: 'rgba(75, 0, 130, 1)',
  ivory: 'rgba(255, 255, 240, 1)',
  khaki: 'rgba(240, 230, 140, 1)',
  lavender: 'rgba(230, 230, 250, 1)',
  lavenderblush: 'rgba(255, 240, 245, 1)',
  lawngreen: 'rgba(124, 252, 0, 1)',
  lemonchiffon: 'rgba(255, 250, 205, 1)',
  lightblue: 'rgba(173, 216, 230, 1)',
  lightcoral: 'rgba(240, 128, 128, 1)',
  lightcyan: 'rgba(224, 255, 255, 1)',
  lightgoldenrodyellow: 'rgba(250, 250, 210, 1)',
  lightgray: 'rgba(211, 211, 211, 1)',
  lightgreen: 'rgba(144, 238, 144, 1)',
  lightgrey: 'rgba(211, 211, 211, 1)',
  lightpink: 'rgba(255, 182, 193, 1)',
  lightsalmon: 'rgba(255, 160, 122, 1)',
  lightseagreen: 'rgba(32, 178, 170, 1)',
  lightskyblue: 'rgba(135, 206, 250, 1)',
  lightslategray: 'rgba(119, 136, 153, 1)',
  lightslategrey: 'rgba(119, 136, 153, 1)',
  lightsteelblue: 'rgba(176, 196, 222, 1)',
  lightyellow: 'rgba(255, 255, 224, 1)',
  lime: 'rgba(0, 255, 0, 1)',
  limegreen: 'rgba(50, 205, 50, 1)',
  linen: 'rgba(250, 240, 230, 1)',
  magenta: 'rgba(255, 0, 255, 1)',
  maroon: 'rgba(128, 0, 0, 1)',
  mediumaquamarine: 'rgba(102, 205, 170, 1)',
  mediumblue: 'rgba(0, 0, 205, 1)',
  mediumorchid: 'rgba(186, 85, 211, 1)',
  mediumpurple: 'rgba(147, 112, 219, 1)',
  mediumseagreen: 'rgba(60, 179, 113, 1)',
  mediumslateblue: 'rgba(123, 104, 238, 1)',
  mediumspringgreen: 'rgba(0, 250, 154, 1)',
  mediumturquoise: 'rgba(72, 209, 204, 1)',
  mediumvioletred: 'rgba(199, 21, 133, 1)',
  midnightblue: 'rgba(25, 25, 112, 1)',
  mintcream: 'rgba(245, 255, 250, 1)',
  mistyrose: 'rgba(255, 228, 225, 1)',
  moccasin: 'rgba(255, 228, 181, 1)',
  navajowhite: 'rgba(255, 222, 173, 1)',
  navy: 'rgba(0, 0, 128, 1)',
  oldlace: 'rgba(253, 245, 230, 1)',
  olive: 'rgba(128, 128, 0, 1)',
  olivedrab: 'rgba(107, 142, 35, 1)',
  orange: 'rgba(255, 165, 0, 1)',
  orangered: 'rgba(255, 69, 0, 1)',
  orchid: 'rgba(218, 112, 214, 1)',
  palegoldenrod: 'rgba(238, 232, 170, 1)',
  palegreen: 'rgba(152, 251, 152, 1)',
  paleturquoise: 'rgba(175, 238, 238, 1)',
  palevioletred: 'rgba(219, 112, 147, 1)',
  papayawhip: 'rgba(255, 239, 213, 1)',
  peachpuff: 'rgba(255, 218, 185, 1)',
  peru: 'rgba(205, 133, 63, 1)',
  pink: 'rgba(255, 192, 203, 1)',
  plum: 'rgba(221, 160, 221, 1)',
  powderblue: 'rgba(176, 224, 230, 1)',
  purple: 'rgba(128, 0, 128, 1)',
  rebeccapurple: 'rgba(102, 51, 153, 1)',
  red: 'rgba(255, 0, 0, 1)',
  rosybrown: 'rgba(188, 143, 143, 1)',
  royalblue: 'rgba(65, 105, 225, 1)',
  saddlebrown: 'rgba(139, 69, 19, 1)',
  salmon: 'rgba(250, 128, 114, 1)',
  sandybrown: 'rgba(244, 164, 96, 1)',
  seagreen: 'rgba(46, 139, 87, 1)',
  seashell: 'rgba(255, 245, 238, 1)',
  sienna: 'rgba(160, 82, 45, 1)',
  silver: 'rgba(192, 192, 192, 1)',
  skyblue: 'rgba(135, 206, 235, 1)',
  slateblue: 'rgba(106, 90, 205, 1)',
  slategray: 'rgba(112, 128, 144, 1)',
  slategrey: 'rgba(112, 128, 144, 1)',
  snow: 'rgba(255, 250, 250, 1)',
  springgreen: 'rgba(0, 255, 127, 1)',
  steelblue: 'rgba(70, 130, 180, 1)',
  tan: 'rgba(210, 180, 140, 1)',
  teal: 'rgba(0, 128, 128, 1)',
  thistle: 'rgba(216, 191, 216, 1)',
  tomato: 'rgba(255, 99, 71, 1)',
  turquoise: 'rgba(64, 224, 208, 1)',
  violet: 'rgba(238, 130, 238, 1)',
  wheat: 'rgba(245, 222, 179, 1)',
  white: 'rgba(255, 255, 255, 1)',
  whitesmoke: 'rgba(245, 245, 245, 1)',
  yellow: 'rgba(255, 255, 0, 1)',
  yellowgreen: 'rgba(154, 205, 50, 1)',
}

export const colorToRgba = (color: string, alpha: number = 1): string => {
  color = color.trim().toLowerCase()

  if (predefinedColors[color]) {
    return predefinedColors[color].replace('1)', `${alpha})`)
  }

  if (color.startsWith('rgb')) {
    const rgba = color.replace(')', `, ${alpha})`).replace('rgb', 'rgba')
    return rgba
  }

  if (color.startsWith('#')) {
    return hexStringToRgba(color, alpha)
  }

  throw new Error('Unsupported color format')
}

/**
 * RGBA 값과 색상 문자열이 알파값을 제외하고 동일한지 확인하는 함수
 * @param rgba RGBA 형식의 색상 문자열 (예: 'rgba(255, 0, 0, 0.5)')
 * @param colorString CSS 색상 이름, RGB 또는 HEX 형식의 색상 문자열
 * @returns 알파값을 제외하고 동일한 색상인지 여부
 */
export const isColorMatchExceptAlpha = (rgba: string, colorString: string): boolean => {
  // RGBA 문자열에서 R, G, B 값 추출
  const rgbaMatch = rgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/)
  if (!rgbaMatch) {
    throw new Error('유효하지 않은 RGBA 형식입니다')
  }

  const r1 = parseInt(rgbaMatch[1], 10)
  const g1 = parseInt(rgbaMatch[2], 10)
  const b1 = parseInt(rgbaMatch[3], 10)

  // 비교할 색상 문자열을 RGBA로 변환 (알파값은 1로 설정)
  let compareRgba: string
  try {
    compareRgba = colorToRgba(colorString, 1)
  } catch {
    return false // 지원되지 않는 색상 형식
  }

  // 변환된 RGBA에서 R, G, B 값 추출
  const compareMatch = compareRgba.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*[\d.]+)?\)/)
  if (!compareMatch) {
    return false
  }

  const r2 = parseInt(compareMatch[1], 10)
  const g2 = parseInt(compareMatch[2], 10)
  const b2 = parseInt(compareMatch[3], 10)

  // R, G, B 값만 비교
  return r1 === r2 && g1 === g2 && b1 === b2
}

// HEX인지 확인
function isHexColor(color: string): boolean {
  return /^#([A-Fa-f0-9]{6}|[A-Fa-f0-9]{3})$/.test(color)
}

// RGB인지 확인
function isRgbaColor(color: string): boolean {
  return /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/.test(color)
}

// css variable을 가져오는 함수
export function getCssVariable(name: string): string {
  return getComputedStyle(document.documentElement).getPropertyValue(`--${name}`).trim()
}

// App에서 전역으로 사용할 css variable을 가져오는 함수
export function getColorVariables(): {
  primary: Record<string, string>
  gray: Record<string, string>
  red: Record<string, string>
} {
  const pick: (name: string) => Record<string, string> = (name: string) =>
    Object.fromEntries(
      Array.from({ length: 9 }, (_, i) => {
        const key = `${(i + 1) * 100}`
        const val = getComputedStyle(document.documentElement)
          .getPropertyValue(`--${name}-${key}`)
          .trim()
        return [key, val]
      }),
    )

  return {
    primary: pick('Primary'),
    gray: pick('Gray'),
    red: pick('Red'),
  }
}

// 밝은 색상인지 확인하는 함수
export function isLightColor(color: string): boolean {
  let r, g, b

  if (color.startsWith('#')) {
    const hex = color.substring(1)
    r = parseInt(hex.substring(0, 2), 16)
    g = parseInt(hex.substring(2, 4), 16)
    b = parseInt(hex.substring(4, 6), 16)
  } else if (color.startsWith('rgb')) {
    const matches = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)/)
    if (matches) {
      r = parseInt(matches[1])
      g = parseInt(matches[2])
      b = parseInt(matches[3])
    } else {
      return false
    }
  } else {
    return false
  }

  // 색상의 밝기 계산 (YIQ 공식)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000
  return yiq >= 160 // 우변 보다 크면 밝음
}

// 색상 이름을 받아서 해당 색상의 HEX 또는 RGBA 값을 반환하는 함수
export function getColor(colorName: string): string {
  if (isHexColor(colorName) || isRgbaColor(colorName)) return colorName
  const cssVar = getCssVariable(colorName)
  if (cssVar && (isHexColor(cssVar) || isRgbaColor(cssVar))) return cssVar
  return '#000000'
}

/**
 * 색상 값을 알파채널 없는 6자리 HEX 형식으로 변환
 * - 3자리 HEX(#RGB) → 6자리 HEX(#RRGGBB)로 확장
 * - 8자리 HEX(#RRGGBBAA) → 6자리 HEX(#RRGGBB)로 변환 (알파 채널 제거)
 * - RGB/RGBA 형식 → HEX 형식으로 변환
 * - 유효하지 않은 형식이면 '#ffffff' 반환
 * @param {string} color - 변환할 색상 문자열 (RGB/RGBA/HEX 형식)
 * @returns {string} 6자리 HEX 색상 코드 (유효하지 않으면 '#ffffff')
 */
export function rgbToHexNoAlpha(color: string): string {
  const DEFAULT_COLOR = '#ffffff'

  if (typeof color !== 'string' || !color.trim()) return DEFAULT_COLOR

  const hexMatch = color.match(/^#([0-9a-fA-F]{3,8})$/)
  if (hexMatch) {
    const hex = hexMatch[1]
    if (hex.length === 3)
      return `#${hex[0]}${hex[0]}${hex[1]}${hex[1]}${hex[2]}${hex[2]}`.toLowerCase()
    if (hex.length === 8) return `#${hex.slice(0, 6)}`.toLowerCase()
    if (hex.length === 6) return color.toLowerCase()
    return DEFAULT_COLOR
  }

  const rgbMatch = color.match(/rgba?\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})/)
  if (!rgbMatch) return DEFAULT_COLOR

  const [r, g, b] = rgbMatch.slice(1, 4).map(Number)
  if ([r, g, b].some(v => v < 0 || v > 255)) return DEFAULT_COLOR

  const toHex = (n: number): string => n.toString(16).padStart(2, '0')
  return `#${toHex(r)}${toHex(g)}${toHex(b)}`.toLowerCase()
}
